var exports = {
  "Ur": "VoiceMessageRecorder.module__voiceButtonWrapper___Vkg4VT",
  "VK": "VoiceMessageRecorder.module__voiceButton___Vkg4VT",
  "qu": "VoiceMessageRecorder.module__voiceButtonIcon___Vkg4VT",
  "hB": "VoiceMessageRecorder.module__holdTooltip___Vkg4VT",
  "Yh": "VoiceMessageRecorder.module__recordingOverlay___Vkg4VT",
  "Zo": "VoiceMessageRecorder.module__overlayInner___Vkg4VT",
  "kK": "VoiceMessageRecorder.module__recordingControls___Vkg4VT",
  "PJ": "VoiceMessageRecorder.module__recordingBar___Vkg4VT",
  "lL": "VoiceMessageRecorder.module__recordingDot___Vkg4VT",
  "O1": "VoiceMessageRecorder.module__timer___Vkg4VT",
  "ou": "VoiceMessageRecorder.module__waveform___Vkg4VT",
  "hd": "VoiceMessageRecorder.module__waveformBar___Vkg4VT",
  "gb": "VoiceMessageRecorder.module__iconButton___Vkg4VT",
  "T5": "VoiceMessageRecorder.module__trashButton___Vkg4VT",
  "jo": "VoiceMessageRecorder.module__sendButton___Vkg4VT",
  "QO": "VoiceMessageRecorder.module__lockIndicatorWrapper___Vkg4VT",
  "zY": "VoiceMessageRecorder.module__lockIndicator___Vkg4VT",
  "bd": "VoiceMessageRecorder.module__lockIndicatorLocked___Vkg4VT",
  "GR": "VoiceMessageRecorder.module__lockIndicatorIcon___Vkg4VT",
  "c8": "VoiceMessageRecorder.module__lockIndicatorCaret___Vkg4VT",
};

module.exports = exports;
